/* rk-softclip.js (r54, 15 Oct 2026, R2). SoftClip combined buy box, see snippets/rk-softclip-picker.liquid.
   Keeps the main product form's id (the chosen 2-Pack variant) and quantity (1 = 2-pack, 2 = 4-pack), the top price,
   the pack prices, sold-out states and the gallery (colour, plus size when an image says so) in step with the choice.
   Nothing changes until the shopper picks something: the first paint is rendered in Liquid with the same default.
   Rollback: remove the render line from the two SoftClip templates (git history before r54).
   2 Nov 2026: up to three sizes (keys xs = Small 8.5cm, small = Medium 10cm, large = Large 12.5cm). Each size in the data carries its
   short name (n) and its gallery words (w), so the gallery and the spoken label follow the data, not a fixed pair. */
(function () {
  'use strict';
  if (window.__rkSoftclip) return;
  window.__rkSoftclip = 1;

  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s*-\s*sold out\s*$/, '').trim(); }

  function init() {
    var root = document.querySelector('[data-rk-softclip]');
    if (!root || root.__rk) return;
    root.__rk = 1;
    var data;
    try { data = JSON.parse(root.querySelector('[data-rk-sc-data]').textContent); } catch (e) { return; }
    var formId = root.getAttribute('data-form');
    var form = document.getElementById(formId);
    var qtyInput = root.querySelector('[data-rk-sc-qty]');
    var live = root.querySelector('[data-rk-sc-live]');
    var colourRadios = $$('input[name^="rk-sc-colour-"]', root);
    var sizeRadios = $$('input[name^="rk-sc-size-"]', root);
    var packRadios = $$('input[name^="rk-sc-pack-"]', root);
    var state = { size: data.default.size, colour: data.default.colour, qty: data.default.qty };

    function sizeName(size) { var s = data.sizes[size]; return (s && s.n) || (size === 'small' ? 'Medium' : 'Large'); }
    function words(size) { var s = data.sizes[size]; return (s && s.w) || (size === 'small' ? ['medium', 'small'] : [size]); }
    function variant(size, colour) { return (data.sizes[size] || { variants: {} }).variants[colour]; }
    function anyIn(size) { var vs = (data.sizes[size] || { variants: {} }).variants; return Object.keys(vs).some(function (k) { return vs[k].available; }); }
    function firstIn(size) { var vs = (data.sizes[size] || { variants: {} }).variants; var c = null; colourRadios.forEach(function (r) { if (!c && vs[r.value] && vs[r.value].available) c = r.value; }); return c; }

    function setPrice(text, soldOut) {
      $$('[id^="main-price-"]').forEach(function (box) {
        if (!box.closest('.product__info-wrapper, .main-product__info-container, product-info')) return;
        $$('.price-item--regular.main-price, .price-item--sale.main-price, .main-comapre-price', box).forEach(function (el) { el.textContent = text; });
        box.classList.remove('price--on-sale');
        box.classList.toggle('price--sold-out', !!soldOut);
      });
    }

    function gallery(init) {
      var mg = document.querySelector('media-gallery');
      if (!mg) return;
      var changed = false;
      var c = norm(state.colour), own = words(state.size), others = [];
      Object.keys(data.sizes).forEach(function (k) { if (k !== state.size) words(k).forEach(function (w) { if (own.indexOf(w) < 0) others.push(w); }); });
      var re = function (w) { return new RegExp('(^|[^a-z])' + w + '([^a-z]|$)'); };
      var hit = function (list, s) { return list.some(function (w) { return re(w).test(s); }); };
      var showById = {};
      $$('.product__media-item', mg).forEach(function (el) {
        var alt = norm(el.dataset.alt), parts = alt.split('|').map(function (s) { return s.trim(); });
        var img = el.querySelector('img'), file = img ? String(img.currentSrc || img.src || '').split('/').pop().split('?')[0].toLowerCase() : '';
        /* 2 Nov 2026: the size part can list sizes ("Oat | Medium, Large", "Always_Display | Medium, Large"), so a photo of the Medium and Large
           (the "Two clip sizes" cards) never shows for the Small. */
        var all = parts[0] === 'always_display', sizes = parts[1] ? parts[1].split(/\s*(?:,|\/|&|\band\b)\s*/) : null;
        /* The colour slide-4 cards say "Two clip sizes" (Medium and Large only). Until their alts carry "| Medium, Large", read that from the file name. */
        if (!sizes && /^rookakon-gallery-softclip-[a-z]+-s4-v2/.test(file)) sizes = ['medium', 'large'];
        var ok = all || parts[0] === c;
        if (ok && sizes) ok = sizes.some(function (s) { return own.some(function (w) { return s.indexOf(w) === 0; }); });
        else if (ok && !all && hit(others, file) && !hit(own, file)) ok = false;
        showById[el.dataset.mediaId] = ok;
      });
      /* A size with no photos of its own yet (the Small until its photos are signed off) keeps the shared Always_Display photos that name no size */
      if (!Object.keys(showById).some(function (k) { return showById[k]; })) {
        $$('.product__media-item', mg).forEach(function (el) { if (norm(el.dataset.alt) === 'always_display') showById[el.dataset.mediaId] = true; });
      }
      $$('.product__media-item', mg).forEach(function (el) {
        var ok = !!showById[el.dataset.mediaId];
        if (el.classList.contains('hidden') === ok) changed = true;
        el.classList.toggle('hidden', !ok);
      });
      $$('.thumbnail-list__item', mg).forEach(function (el) {
        var ok = showById[el.dataset.target];
        if (ok === undefined) return;
        el.classList.toggle('hidden', !ok);
      });
      if (init && !changed) return; /* first paint already matches the choice: touch nothing */
      var shown = $$('.product__media-item', mg).filter(function (el) { return !el.classList.contains('hidden'); });
      var dots = $$('.slider-counter__link', mg);
      /* r55 FX3 (Q2-14): one dot per photo on screen. The theme's slider re-filters the dots by the form's variant after a change (the SoftClip form holds a
         2-Pack variant, so it hid the wrong dots: White showed 7 photos and 2 dots). The count is set again after the slider has finished. */
      function syncDots() { dots.forEach(function (d, i) { var on = i < shown.length; d.classList.toggle('hidden', !on); d.style.display = on ? '' : 'none'; }); }
      syncDots();
      ['GalleryViewer', 'GalleryThumbnails'].forEach(function (p) {
        var el = mg.querySelector('[id^="' + p + '"]');
        try { if (el && el.initPages) el.initPages(); if (el && el.update) el.update(); } catch (e) {}
      });
      syncDots(); setTimeout(syncDots, 60); setTimeout(syncDots, 350); setTimeout(syncDots, 1000);
      var first = shown[0];
      if (first) {
        $$('.product__media-item.is-active', mg).forEach(function (s) { s.classList.remove('is-active'); });
        first.classList.add('is-active');
        var list = first.parentElement;
        try { list.scrollTo({ left: 0 }); } catch (e) { list.scrollLeft = 0; }
      }
    }

    function render(fromUser) {
      var v = variant(state.size, state.colour);
      colourRadios.forEach(function (r) {
        var cv = variant(state.size, r.value);
        r.disabled = !(cv && cv.available);
        r.checked = r.value === state.colour;
        var lab = root.querySelector('label[for="' + r.id + '"]');
        if (lab) {
          lab.title = r.value + (r.disabled ? ' (sold out)' : '');
          var vh = lab.querySelector('.visually-hidden');
          if (vh) vh.textContent = r.value + (r.disabled ? ', sold out' : '');
        }
      });
      sizeRadios.forEach(function (r) { r.disabled = !anyIn(r.value); r.checked = r.value === state.size; });
      var two = packRadios.filter(function (r) { return r.value === '1'; })[0];
      var four = packRadios.filter(function (r) { return r.value === '2'; })[0];
      var can2 = !!(v && v.available), can4 = !!(v && v.four);
      if (two) two.disabled = !can2;
      if (four) four.disabled = !can4;
      if (state.qty === 2 && !can4) state.qty = 1;
      packRadios.forEach(function (r) { r.checked = Number(r.value) === state.qty; });
      var p2 = root.querySelector('[data-rk-sc-p2]'), p4 = root.querySelector('[data-rk-sc-p4]');
      if (p2) p2.textContent = can2 ? v.p2 : 'Sold out';
      if (p4) p4.textContent = can4 ? v.p4 : 'Sold out';
      var name = root.querySelector('[data-rk-sc-colour-name]');
      if (name) name.textContent = state.colour;
      form = form || document.getElementById(formId);
      if (form && v) {
        var idIn = form.querySelector('input[name="id"]');
        if (idIn) { idIn.value = String(v.id); idIn.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      if (qtyInput) qtyInput.value = String(state.qty);
      var btn = form && form.querySelector('[type="submit"][name="add"]');
      if (btn) btn.disabled = !can2;
      if (fromUser) {
        setPrice(can2 ? (state.qty === 2 ? v.p4 : v.p2) : 'Sold out', !can2);
        gallery();
        if (live) live.textContent = state.colour + ', ' + sizeName(state.size) + ', ' + (state.qty === 2 ? '4 Pack' : '2 Pack') + (can2 ? ', ' + (state.qty === 2 ? v.p4 : v.p2) : ', sold out');
      }
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio') return;
      if (t.name.indexOf('rk-sc-colour-') === 0) state.colour = t.value;
      else if (t.name.indexOf('rk-sc-size-') === 0) {
        state.size = t.value;
        var cv = variant(state.size, state.colour);
        if (!(cv && cv.available)) state.colour = firstIn(state.size) || state.colour;
      } else if (t.name.indexOf('rk-sc-pack-') === 0) state.qty = Number(t.value) || 1;
      render(true);
    });

    /* Safety net: whatever Shrine's product form sends to /cart/add, it adds the chosen 2-Pack and quantity. */
    var orig = window.fetch;
    window.fetch = function (u, o) {
      try {
        var url = String((u && u.url) || u);
        if (/\/cart\/add/.test(url) && o && o.body instanceof FormData && form && o.body.get('product-id') === (form.querySelector('input[name="product-id"]') || {}).value) {
          var v = variant(state.size, state.colour);
          if (v) {
            var nb = new FormData();
            o.body.forEach(function (val, k) { if (!/^items\[|^id$|^quantity$/.test(k)) nb.append(k, val); });
            nb.append('id', String(v.id));
            nb.append('quantity', String(state.qty));
            o = Object.assign({}, o, { body: nb });
            arguments[1] = o;
          }
        }
      } catch (e) {}
      return orig.apply(this, arguments);
    };
    window.rkSoftclipState = function () { var v = variant(state.size, state.colour); return { size: state.size, name: sizeName(state.size), colour: state.colour, qty: state.qty, id: v && v.id, price: v && (state.qty === 2 ? v.p4 : v.p2), cents: v && (state.qty === 2 ? v.c4 : v.c2) }; };
    render(false);
    gallery(true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
